import {useContext} from 'react';
import {KioskoContext} from './KioskoContext';

export const useKiosko = () => {
  const context = useContext(KioskoContext);

  if (!context) {
    throw new Error('useKiosko must be used within a KioskoProvider');
  }

  return context;
};
